import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRightIcon, AlertCircleIcon } from 'lucide-react';
export function Hero() {
  return <section className="bg-gradient-to-b from-[#FDF8F3] to-white pt-8 pb-16 px-6 md:px-12 overflow-hidden" data-id="element-173">
      <div className="max-w-6xl mx-auto" data-id="element-174">
        {/* Urgent Badge */}
        <FadeIn data-id="element-175">
          <div className="flex justify-center mb-6" data-id="element-176">
            <div className="inline-flex items-center gap-2 bg-[#F5A623] text-white px-6 py-3 rounded-full shadow-lg" data-id="element-177">
              <AlertCircleIcon className="w-5 h-5" data-id="element-178" />
              <span className="font-bold text-sm uppercase tracking-wide" data-id="element-179">
                Detección Temprana del Autismo (18-24 meses)
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Hero Image - Now First */}
        <FadeIn delay={100} data-id="element-180">
          <div className="max-w-4xl mx-auto mb-12 relative" data-id="element-181">
            {/* Decorative elements for emphasis */}
            <div className="absolute -inset-4 bg-gradient-to-r from-[#3BBFAD]/20 via-[#F5A623]/20 to-[#3BBFAD]/20 blur-2xl rounded-3xl" data-id="element-182"></div>
            <div className="absolute inset-0 bg-[#3BBFAD]/10 transform rotate-1 rounded-2xl -z-10" data-id="element-183"></div>

            <div className="relative" data-id="element-184">
              <img src="https://cdn.magicpatterns.com/uploads/eEWAeBjzcp95cAYxTKj3ys/imagen_perfecta_para_mi_ebooks.png" alt="Madre e hijo jugando con bloques - Detección temprana del autismo" className="w-full rounded-2xl shadow-2xl border-4 border-white transform hover:scale-[1.02] transition-transform duration-500" data-id="element-185" />
              {/* Overlay badge on image */}
              <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-[#3BBFAD]/20" data-id="element-186">
                <p className="text-[#1B2A4A] font-semibold text-center" data-id="element-187">
                  <span className="text-[#3BBFAD] font-bold" data-id="element-188">
                    Cada día cuenta
                  </span>{' '}
                  en el desarrollo de tu hijo
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Main Headline - More Urgent */}
        <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-189">
          <FadeIn delay={200} data-id="element-190">
            <p className="text-[#F5A623] font-bold tracking-wide uppercase text-sm mb-4 flex items-center justify-center gap-2" data-id="element-191">
              <span className="w-2 h-2 bg-[#F5A623] rounded-full animate-pulse" data-id="element-192"></span>
              Guía práctica para padres con niños de 18–24 meses
              <span className="w-2 h-2 bg-[#F5A623] rounded-full animate-pulse" data-id="element-193"></span>
            </p>
          </FadeIn>

          <FadeIn delay={300} data-id="element-194">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1B2A4A] leading-tight mb-6" data-id="element-195">
              Si sospechas algo en el desarrollo de tu hijo…
              <br data-id="element-196" />
              <span className="text-[#F5A623] font-bold" data-id="element-197">no esperes.</span>
              <br data-id="element-198" />
              <span className="italic text-[#3BBFAD] text-3xl md:text-4xl" data-id="element-199">
                Actúa con claridad.
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={400} data-id="element-200">
            <div className="max-w-[720px] mx-auto text-left space-y-5 text-[#1B2A4A]/80 text-lg leading-relaxed font-sans bg-white/50 p-8 rounded-2xl border border-[#3BBFAD]/10" data-id="element-201">
              <p className="font-semibold text-[#1B2A4A] text-xl" data-id="element-202">
                La ventana de intervención temprana es breve.
              </p>
              <p data-id="element-203">
                Hay un tipo de miedo que no se siente como pánico. Se siente
                como volver a ver el mismo video en tu teléfono… otra vez.
              </p>
              <p data-id="element-204">Como contar "cuántas veces respondió" hoy.</p>
              <p data-id="element-205">
                Como decirte: "seguro estoy exagerando"… y al minuto siguiente
                pensar: "¿y si no?"
              </p>
              <div className="bg-[#FDF8F3] p-6 rounded-xl border-l-4 border-[#F5A623] mt-6" data-id="element-206">
                <p className="font-semibold text-[#1B2A4A] mb-3" data-id="element-207">
                  Y lo peor no es la duda.
                </p>
                <p data-id="element-208">
                  Lo peor es no saber qué hacer{' '}
                  <span className="font-bold text-[#F5A623]" data-id="element-209">mañana</span> sin
                  caer en dos extremos:
                </p>
                <ul className="list-disc pl-5 space-y-2 ml-2 mt-3" data-id="element-210">
                  <li data-id="element-211">Volverte detective 24/7, o</li>
                  <li data-id="element-212">Esperar meses con esa ansiedad instalada en el pecho.</li>
                </ul>
              </div>
              <p className="text-2xl font-serif italic text-[#1B2A4A] pt-4 text-center" data-id="element-213">
                La Ruta Clara existe para{' '}
                <span className="text-[#3BBFAD] font-bold" data-id="element-214">ese momento</span>.
              </p>
            </div>
          </FadeIn>
        </div>

        {/* CTA Button - More Prominent */}
        <FadeIn delay={500} data-id="element-215">
          <div className="text-center" data-id="element-216">
            <a href="#pricing" className="inline-flex items-center gap-3 bg-[#3BBFAD] text-white px-10 py-5 rounded-full text-xl font-bold hover:bg-[#2DA897] hover:scale-105 transition-all duration-300 shadow-[0_0_30px_rgba(59,191,173,0.4)] hover:shadow-[0_0_50px_rgba(59,191,173,0.6)]" data-id="element-217">
              Quiero mi Ruta Clara Ahora
              <ArrowRightIcon className="w-6 h-6" data-id="element-218" />
            </a>
            <p className="mt-4 text-sm text-[#1B2A4A]/60" data-id="element-219">
              Descarga inmediata • Empieza hoy mismo
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}